import { pathJoin } from 'src/reducers/routing/utils'

import { createDataSyncRoutesMap } from './data-sync'

// PRO-400: the `pricing`, `services`, `integrations` and `municipalities`
// routes left this section — Pricing moved to Contract Management settings as
// "Legacy Pricing" (its route subtree now lives under `product-management`,
// see product-management.tsx / createPricingRoutesMap), Services moved to
// Tickets settings, Municipalities to Map Layers & Zones, and Integrations was
// removed (PRO-140). The old `.../crm/pricing`, `.../crm/services` and
// `.../crm/municipalities` URLs still resolve: crm's index renders redirects to
// the new homes (deep links / bookmarks never 404).
export const createCRMRoutesMap = (prefix: string) => ({
  'scheduled-exports': pathJoin(prefix)('scheduled-exports').chain,
  'property-type': pathJoin(prefix)('property-type').chain,
  'contact-tags': pathJoin(prefix)('contact-tags').chain,
  'billing-runs': pathJoin(prefix)('billing-runs').chain,
  'data-sync': pathJoin(prefix)('data-sync').chainMapAuto(
    createDataSyncRoutesMap
  ),
  'service-type': pathJoin(prefix)('service-type').chain,
  'field-configuration': pathJoin(prefix)('field-configuration').chain,
  'service-responsibilities': pathJoin(prefix)('service-responsibilities')
    .chain,
  industries: pathJoin(prefix)('industries').chain,
})
